import api from "ApiClient";
import { ApiURL } from "utils/Actions";
import { common } from "utils/Wording";

type PromisePropType = {
  path: string;
  type?: string;
  body?: any;
  queryParams?: any;
  dataRequired?: boolean;
};

type PromiseResponseType = {
  type?: string;
  error: boolean;
  data?: any;
  errorMsg?: string[];
};

export const patchUpdatePasswordToken = async (email: string): Promise<PromiseResponseType> => {
  const body = { email };
  return api
    .patch(ApiURL.updatePasswordToken, body)
    .then(res => {
      return res?.data?.data?.emailSent && res?.data?.data?.tokenUpdated
        ? {
            error: false,
            data: res.data
          }
        : {
            error: true,
            errorMsg: [common.emailFail]
          };
    })
    .catch(error => {
      return {
        error: true,
        errorMsg: error.response?.data && error.response.data.errors
      };
    });
};

export const patchResetPassword = async (email: string): Promise<PromiseResponseType> => {
  const body = { email };
  return api
    .patch(ApiURL.resetPassword, body)
    .then(res => {
      return res?.data?.data?.emailSent && res?.data?.data?.tokenUpdated
        ? {
            error: false,
            data: res.data
          }
        : {
            error: true,
            errorMsg: [common.emailFail]
          };
    })
    .catch(error => {
      return {
        error: true,
        errorMsg: error.response?.data && error.response.data.errors
      };
    });
};

export const createPutRequest = async ({
  path,
  body,
  queryParams,
  type
}: PromisePropType): Promise<PromiseResponseType> => {
  return api
    .put(path, body, { params: queryParams })
    .then(res => {
      return {
        type,
        error: false,
        data: res.data
      };
    })
    .catch(error => {
      return {
        error: true,
        errorMsg: error.response?.data?.errors ? error.response.data.errors : [error.message]
      };
    });
};

export const createPatchRequest = async ({
  path,
  queryParams,
  type,
  body
}: PromisePropType): Promise<PromiseResponseType> => {
  return api
    .patch(path, body, { params: queryParams })
    .then(res => {
      return {
        type,
        error: false,
        data: res.data
      };
    })
    .catch(error => {
      return {
        error: true,
        errorMsg: error.response?.data?.errors ? error.response.data.errors : [error.message]
      };
    });
};

export const createGetRequest = async ({
  type,
  path,
  dataRequired,
  queryParams
}: PromisePropType): Promise<PromiseResponseType> => {
  return api
    .get(path, { params: queryParams })
    .then(res => {
      if (dataRequired && !res.data) {
        throw new Error(common.loadingError);
      }
      return {
        type,
        error: false,
        data: res.data
      };
    })
    .catch(error => {
      return {
        error: true,
        errorMsg: error.response?.data?.errors ? error.response.data.errors : [error.message]
      };
    });
};

export const createPostRequest = async ({
  type,
  path,
  body,
  queryParams
}: PromisePropType): Promise<PromiseResponseType> => {
  return api
    .post(path, body, { params: queryParams })
    .then(res => {
      return {
        type,
        error: false,
        data: res.data
      };
    })
    .catch(error => {
      return {
        error: true,
        errorMsg: error.response?.data?.errors ? error.response.data.errors : [error.message]
      };
    });
};
